import React from 'react'
import Activity from '../components/Activity'
import UserSelector from '../components/UserSelector'
import { Outlet } from 'react-router-dom'

const BrainLayout = () => {
  return (
    <div>
      <div className='dashboard-heading'>
        <div className='content-container m-0'>
          <h2>Neuro Diagnosis</h2>
          <p className='m-0'>Upload and check diagnosis reports.</p>
        </div>
        <Activity />
      </div>

      <UserSelector />

      <Outlet />
    </div>
  )
}

export default BrainLayout
